



















import { Component, Vue, Prop } from 'vue-property-decorator';

import ShareOffer, {
  ShareOfferGATracking
} from '@/components/ShareOffer/ShareOffer.vue';

@Component({
  components: {
    ShareOffer
  }
})
export default class ShareOfferTooltip extends Vue {
  @Prop({ required: true }) isVisible!: boolean;
  @Prop({ required: true }) data!: any;
  @Prop({ default: 'offer-list' }) origin?: string;
  @Prop() gaTracking?: ShareOfferGATracking;
}
